import React from 'react';
interface LogoProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  'data-id'?: string;
}
export const Logo: React.FC<LogoProps> = ({
  width = 120,
  height = 'auto',
  className = '',
  'data-id': dataId
}) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pm4UkK8deqBVK6XZPtpZTf/vitau-logo-white.svg" alt="Vitau" width={width} height={height} className={className} data-id={dataId} />;
};